import { useEffect, useState } from "react";
import { Alert, Button, Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import paymentApi from "../../api/paymentApi";

const RejectedTransactions = () => {
  const [rejectedTransactions, setRejectedTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRejectedTransactions();
  }, []);
  const fetchRejectedTransactions = async () => {
    try {
      const response = await paymentApi.getRejectedPaymentStatus();
      setRejectedTransactions(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching rejected transactions:", error);
      setError(error.message);
      setLoading(false);
    }
  };
  const handleApproveTransaction = async (transactionId) => {
    try {
      await paymentApi.approveTransaction(transactionId);

      Swal.fire({
        title: "Transaction Approved!",
        text: "The transaction has been successfully approved.",
        icon: "success",
        confirmButtonText: "OK",
      });

    } catch (error) {
      console.error("Error approving transaction:", error);
      setError("Failed to approve transaction. Please try again.");

      Swal.fire({
        title: "Error!",
        text: "Failed to approve the transaction. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  return (
    <div className="container mt-4">
      <h2 className="mb-3">Rejected Transactions</h2>
      {loading && (
        <div className="text-center mt-4">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}

      {!loading && error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}

      {!loading && !error && rejectedTransactions.length === 0 && (
        <Alert variant="info" className="mt-3">
          No rejected transactions found.
        </Alert>
      )}

      {!loading && rejectedTransactions.length > 0 && (
        <Table striped bordered hover responsive className="mt-4">
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>User</th>
              <th>Amount</th>
              <th>Requested Credits</th>
              <th>Rejected At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rejectedTransactions.map((transaction) => (
              <tr key={transaction.transactionId}>
                <td>{transaction.transactionId}</td>
                <td>
                  {transaction.userEmail}-{transaction.userId}
                </td>
                <td>{transaction.amount}</td>
                <td>{transaction.creditsRequested}</td>
                <td>{new Date(transaction.approvedAt).toLocaleString()}</td>
                <td>
                  <Button
                    variant="success"
                    onClick={() =>
                      handleApproveTransaction(transaction.transactionId)
                    } // Pass transactionId
                  >
                    Approve
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default RejectedTransactions;
